import React from 'react';
import TalenteesLogo from '../image/Talentees-02.png';
import { useI18n } from '../i18n';

export const AboutPage: React.FC = () => {
  const { t } = useI18n();
  const a = t.about;

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <header className="px-8 py-6">
        <a href="/">
          <img src={TalenteesLogo} alt="Talentees" className="h-8" />
        </a>
      </header>

      <main className="flex-1 w-full max-w-3xl mx-auto px-6 py-20">

        <div className="mb-20">
          <p className="text-[#28e675] text-sm font-medium tracking-widest uppercase mb-4">
            {a.label}
          </p>
          <h1 className="text-white font-display text-4xl sm:text-5xl leading-tight mb-8">
            {a.title}<br />
            <span className="text-white/35">{a.titleMuted}</span>
          </h1>
          <p className="text-white/55 text-base leading-relaxed max-w-2xl">
            {a.intro}
          </p>
        </div>

        <div>
          <p className="text-white/30 text-xs font-medium tracking-widest uppercase mb-8">
            {a.valuesLabel}
          </p>
          <div className="flex flex-col" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
            {a.values.map((value, i) => (
              <div
                key={i}
                className="py-8 flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-12"
                style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}
              >
                <div className="shrink-0 sm:w-48">
                  <span className="text-white font-semibold text-sm leading-snug">{value.label}</span>
                </div>
                <p className="text-white/45 text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 text-center">
          <p className="text-white/30 text-sm mb-6">{a.ctaLabel}</p>
          <a
            href="mailto:hello@talentees.net"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium text-black bg-[#28e675] hover:bg-[#34f581] transition-colors"
          >
            hello@talentees.net
          </a>
        </div>
      </main>

      <footer className="px-8 py-6 text-center">
        <a href="/" className="text-white/30 hover:text-white/60 text-sm transition-colors">
          {a.backHome}
        </a>
      </footer>
    </div>
  );
};
